import { axios_instance } from "../api/axios_instance";

const getTableStyles = () => {
  return `.withheldlist-checkbox{
        width: 3.5%;
    }
    .withheldlist-lead-id{
        width: 4%;
    }
    .withheldlist-car-details{
        width: 8%;
    }
    .withheldlist-customer{
        width: 10%;
    }
    .withheldlist-city{
        width: 8%;
    }
    .withheldlist-ledger-balance{
        width: 10%;
    }
    .withheldlist-tranche-name{
        width: 8%;
    }
    .withheldlist-rc-status{
        width: 9%;
    }
    .withheldlist-withheld-amount{
        width: 9%;
    }
    .withheldlist-actual-charges{
        width: 9%;
    }
    .withheldlist-tranche-amount{
        width: 9%;
    }
    .withheldlist-rto-agent{
        width: 8%;
    }
    .withheldlist-pending-amount{
        width: 9%;
    }
    `;
};

const getSortingClass = (sortingColumns, column) => {
  return sortingColumns[column] === 1
    ? "_asc"
    : sortingColumns[column] === -1
    ? "_desc"
    : "";
};

const validatePayeeDetails = (state, setState) => {
  let validationFlag = true;
  const payableAcNumber = state.payeeData.payable_ac_number;
  [
    "payee_type",
    "payee_name",
    "payee_ac_number",
    "confirmPayeeAcNumber",
    "payee_ifsc_code",
    "payee_bank_name",
    "payee_branch_name",
  ].forEach((classId) => {
    removeErrorClass(classId, state, setState, false);
  });
  if (payableAcNumber === "Direct Payment") validationFlag = false;

  if (!state.payeeData.payee_type) {
    appendErrorClass(
      "payee_type",
      "Please fill the mandatory information",
      state
    );
    setState({ ...state });
    return false;
  } else if (!state.payeeData.payee_name) {
    appendErrorClass(
      "payee_name",
      "Please fill the mandatory information",
      state
    );
    setState({ ...state });
    return false;
  } else if (!state.payeeData.payee_ac_number && validationFlag) {
    appendErrorClass(
      "payee_ac_number",
      "Please fill the mandatory information",
      state
    );
    setState({ ...state });
    return false;
  } else if (!state.payeeData.payee_ifsc_code && validationFlag) {
    appendErrorClass(
      "payee_ifsc_code",
      "Please fill the mandatory information",
      state
    );
    setState({ ...state });
    return false;
  } else if (!state.payeeData.payee_bank_name && validationFlag) {
    appendErrorClass(
      "payee_bank_name",
      "Please fill the mandatory information",
      state
    );
    setState({ ...state });
    return false;
  } else if (!state.payeeData.payee_branch_name && validationFlag) {
    appendErrorClass(
      "payee_branch_name",
      "Please fill the mandatory information",
      state
    );
    setState({ ...state });
    return false;
  }
  setState({ ...state });
  return true;
};

const appendErrorClass = (classId, msg, state) => {
  state.payeeData[`${classId}_Class`] = "errorInput";
  state.payeeData[`error_${classId}_Msg`] = msg;
};

const removeErrorClass = (classId, state, setState, updateState = false) => {
  state.payeeData[`${classId}_Class`] = "";
  state.payeeData[`error_${classId}_Msg`] = null;
  if (updateState) setState({ ...state });
};

const payeeBalTotal = (state, setState) => {
  const { disburse_paid_amt } = state.payeeData;
  if (isNaN(disburse_paid_amt)) return;
  let finalTotal = +state.payeeData.disburse_payable_amt;
  if (finalTotal < +disburse_paid_amt) {
    state.payeeData.disburse_paid_amt_class = "errorInput";
    window.alert("Paid amount should not be greater than payable amount.");
    state.payeeData.disburse_paid_amt = finalTotal;
    state.payeeData.disburse_bal_amt = 0;
    setState({ ...state });
    return;
  }
  state.payeeData.disburse_paid_amt_class = "";
  finalTotal -= +state.payeeData.disburse_paid_amt;
  state.payeeData.disburse_bal_amt = finalTotal;
  setState({ ...state });
};

const ifscMapping = async (state, setState) => {
  const ifsc = state.payeeData.payee_ifsc_code;
  if (ifsc.length === 11) {
    removeErrorClass("payee_ifsc_code", state, setState, false);
    try {
      const response = await axios_instance({
        url: "/dts/ifscMapping",
        method: "POST",
        data: { ifsc, action: "ifsc" },
      });
      if (response.status === 200) {
        const result = response.data.result;
        state.payeeData.payee_bank_name = result.bank_name;
        state.payeeData.payee_branch_name = result.branch_name;
      } else {
        state.payeeData.payee_bank_name = "";
        state.payeeData.payee_branch_name = "";
      }
    } catch (error) {
      state.payeeData.payee_bank_name = "";
      state.payeeData.payee_branch_name = "";
    }
  } else {
    appendErrorClass(
      "payee_ifsc_code",
      "IFSC code must be of 11 characters",
      state
    );
  }
  setState({ ...state });
};

const fetchPayeeDetails = async (state, setState) => {
  const payeeType = state.payeeData.payee_type;
  if ([1, 7, 9].includes(+payeeType)) {
    try {
      const resp = await axios_instance({
        url: "/dts/getDealerProfile",
        method: "POST",
        data: {
          lead_id: state.payeeData.finance_lead_id,
          dealer_id: state.payeeData.dealer_id,
          payee_type_val: +payeeType,
          action: "payee_type",
        },
      });
      if (resp.status === 200) {
        const result = resp.data.result;
        state.payeeData.payee_name = result.payee_name;
        state.payeeData.payee_ac_number = result.payee_account;
        state.payeeData.payee_ifsc_code = result.ifsc_code;
        state.payeeData.payee_bank_name = result.bank;
        state.payeeData.payee_branch_name = result.branch;
      } else {
        resetBankFields(state);
      }
    } catch (error) {
      resetBankFields(state);
    }
  } else {
    resetBankFields(state);
  }
  setState({ ...state });
};

const resetBankFields = (state) => {
  state.payeeData.payee_name = "";
  state.payeeData.payee_ac_number = "";
  state.payeeData.payee_ifsc_code = "";
  state.payeeData.payee_bank_name = "";
  state.payeeData.payee_branch_name = "";
};

export {
  getTableStyles,
  getSortingClass,
  validatePayeeDetails,
  payeeBalTotal,
  ifscMapping,
  fetchPayeeDetails,
};
